import React from 'react';
// import moment from 'moment';
// import FilterButtons from "./components/FilterButtons";
import { EditSettingModal } from './components/EditSettingModal';

function getEditCell({ value, row }: any) {
  if (value != null) {
    return <EditSettingModal data={row} readOnly={false} />;
  } else {
    return '';
  }
}

export const columns = [
  {
    column: {
      Header: 'Edit',
      accessor: 'settingId',
      filterable: false,
      resizable: true,
      width: 45,
      Cell: getEditCell,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'ID',
      accessor: 'settingId',
      resizable: true,
      type: 'string',
      width: 50,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Setting',
      accessor: 'settingName',
      resizable: true,
      // width: 400,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Value',
      accessor: 'settingValue',
      resizable: true,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Description',
      accessor: 'settingDescription',
      resizable: true,
      type: 'string',
    },
    type: 'string',
  },
];

/** Filter Buttons - none needed for this screen */
export const filterButtons = [];

export const editSettingFormFieldConfig = [
  {
    name: 'settingId',
    label: 'Setting ID',
    //type: "input",
    readOnly: true,
    gqlDataType: 'number',
  },
  {
    name: 'settingName',
    label: 'Name',
    //type: "input",
    readOnly: true,
    gqlDataType: 'string',
  },
  {
    name: 'settingValue',
    label: 'Value',
    type: 'input',
    readOnly: false,
    gqlDataType: 'string',
  },
  {
    name: 'settingDescription',
    label: 'Description',
    type: 'input',
    readOnly: false,
    gqlDataType: 'string',
  },
];
